import { useState } from "react";
import { ArrowRight } from "lucide-react";

export default function ManualJoinView() {
  const [code, setCode] = useState("");
  const trimmed = code.trim().toUpperCase();
  const valid = /^[A-Z0-9]{4,6}$/.test(trimmed);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!valid) return;
    window.location.href = `/join/${trimmed}`;
  };

  return (
    <div className="min-h-screen bg-rc-cream font-sans antialiased">
      <div className="max-w-xl mx-auto px-4 py-5 sm:py-8">
        <div className="bg-rc-paper rounded-rc-xl shadow-cardLg overflow-hidden min-h-[calc(100vh-4rem)] flex flex-col border border-rc-fog">
          <div className="px-6 pt-6">
            <div className="flex items-center justify-between mb-1">
              <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-[0.18em] text-rc-charcoal uppercase">
                <span className="relative inline-flex w-1.5 h-1.5">
                  <span className="absolute inset-0 rounded-full bg-rc-berry opacity-70 animate-shimmer" />
                  <span className="relative inline-flex w-1.5 h-1.5 rounded-full bg-rc-berry" />
                </span>
                Beitreten
              </span>
              <span className="text-[11px] font-semibold tracking-[0.18em] text-rc-slate uppercase">
                READYCAL
              </span>
            </div>
          </div>

          <div className="px-6 pt-6 pb-6 flex-1 flex flex-col">
            <main className="flex-1 flex flex-col gap-7">
              <div className="pt-1">
                <p className="text-[11px] font-semibold tracking-[0.18em] text-rc-berry uppercase mb-3">
                  Event-Code eingeben
                </p>
                <h1 className="text-rc-black font-bold text-[30px] sm:text-[34px] leading-[1.1] tracking-[-0.02em] text-balance">
                  Mit Code beitreten.
                </h1>
                <p className="text-[15px] text-rc-charcoal mt-4 leading-[1.55]">
                  Gib den <strong className="font-semibold text-rc-black">4–6-stelligen Code</strong>{" "}
                  ein, den ihr von der Moderation bekommen habt. Kein Account, keine App.
                </p>
              </div>

              <form onSubmit={onSubmit} className="flex flex-col gap-3" noValidate>
                <label
                  htmlFor="join-code"
                  className="text-[11px] font-semibold tracking-[0.14em] text-rc-charcoal uppercase"
                >
                  Event-Code
                </label>
                <input
                  id="join-code"
                  type="text"
                  inputMode="text"
                  autoComplete="off"
                  autoCapitalize="characters"
                  spellCheck={false}
                  autoFocus
                  value={code}
                  onChange={(e) =>
                    setCode(e.target.value.replace(/[^A-Za-z0-9]/g, "").slice(0, 6))
                  }
                  placeholder="XK9F2"
                  maxLength={6}
                  aria-invalid={code.length > 0 && !valid}
                  className="w-full bg-rc-paper border-[1.5px] border-rc-fog rounded-xl px-5 py-4 text-[26px] sm:text-[28px] font-bold tracking-[0.22em] uppercase text-rc-black placeholder:text-rc-slate/45 placeholder:font-semibold focus:outline-none focus:border-rc-berry focus:ring-2 focus:ring-rc-berry/15 transition-colors ease-rc-out text-center tabular-nums"
                />
                <p className="text-[12px] text-rc-slate leading-[1.5]">
                  4–6 Zeichen, Buchstaben oder Zahlen. Beispiel:{" "}
                  <span className="font-mono font-semibold text-rc-charcoal tracking-[0.18em]">
                    XK9F2
                  </span>
                  .
                </p>

                <div className="mt-4 flex justify-center">
                  <button
                    type="submit"
                    disabled={!valid}
                    className="group inline-flex items-center gap-2 bg-rc-berry hover:bg-rc-berry-700 disabled:bg-rc-fog disabled:text-rc-slate disabled:cursor-not-allowed text-rc-paper font-semibold rounded-pill pl-6 pr-5 py-3.5 text-[15px] transition-colors ease-rc-out shadow-berry disabled:shadow-none active:scale-[0.97]"
                  >
                    Beitreten
                    <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
                  </button>
                </div>
              </form>

              <div className="mt-auto border-t border-rc-fog pt-5">
                <p className="text-[12px] text-rc-slate leading-[1.55]">
                  Tipp: Den QR-Code auf der Bühne scannen führt euch direkt zur Antwort, ohne Code
                  zu tippen.
                </p>
              </div>
            </main>
          </div>
        </div>

        <p className="text-center text-[10px] font-semibold tracking-[0.18em] text-rc-slate uppercase mt-4">
          Ein READYCAL-Produkt
        </p>
      </div>
    </div>
  );
}
